import Head from 'next/head';
import BreadCrumbs from '@/components/Breadcrumbs';
import { BreadcrumbCode } from '@/components/codeHighlights/Breadcrumbs';

const Page = () => {
  return (
    <>
      <Head>
        <title>Breadcrumbs</title>
      </Head>

      <h1>Breadcrumbs</h1>
      <BreadCrumbs />
      <div className="mt-5">
        <h2>Breadcrumb HTML-Code Examples</h2>
        <BreadcrumbCode />
      </div>
    </>
  );
};

export default Page;
